import { Component } from '@angular/core';
import { ActivatedRoute, RouterLink } from "@angular/router";
import { AuthService } from '../../services/auth.service';
import { Store } from '@ngrx/store';
import { AuthUser } from '../../../../globalTypes/auth.types';
import { authUserFeature } from '../../store/authUser.store';
import { filter, lastValueFrom, take } from 'rxjs';
import { Logger } from '../../helper/logger';
import { sleep } from '../../../../globalTypes/_helpers';
import { accountFeature } from '../../store/account.store';
import { AccountService } from '../../services/account.service';
import { MatSnackBar } from "@angular/material/snack-bar";
const log = new Logger("EmailVerifiedComponent")

@Component({
  selector: 'msh-email-verified',
  imports: [RouterLink],
  template: `
<div class="mt-40 text-center">

  @if(authUser){
    <div class="text-2xl mb-8">Your email has been verified!</div> 
    <div>Redirecting to the <span class="cursor-pointer text-orange-400" [routerLink]="'/login'">login page</span>...</div>
  } @else {
    <div class="text-2xl mb-8">Your email is being verified!</div> 
    <div>Navigate to the <span class="cursor-pointer text-orange-400" [routerLink]="'/login'">login page</span></div>
  } 
</div>
  `,
  styles: ``
})
export class EmailVerifiedComponent {
  authUser!: AuthUser;
  constructor(
    private authService: AuthService,
    private accountService: AccountService,
    private snackbar: MatSnackBar,
    private store: Store,
    private route: ActivatedRoute
  ){
    this.store.select(authUserFeature.selectUser).pipe(filter(u=>!!u),take(1)).subscribe(async user => {
      log.log({user, isEmailVerified: user?.isEmailVerified})
      if(!user) return;
      this.authUser = user;
      // FIXME figure out if user data should already return true for this or not // if(user.isEmailVerified) return;
      try {
        await this.authService.emailVerifiedCheck();
        await sleep(2000);
      } catch (error) {
        log.error("Error during email verification check:", error);
        this.snackbar.open("Error during email verification check. Please try again.", "Close", {duration: 3000});
      }
      // this is too early to accept the invite because the user needs to log out and back in
      // const hasReceivedInvites = await lastValueFrom(this.store.select(accountFeature.selectInvitationsReceived).pipe(take(1)));
      // if(hasReceivedInvites.length > 0){
      //   this.accountService.acceptInvite(hasReceivedInvites[0]);
      // }
      this.route.queryParams.subscribe(params => {
        const email = params['email'];
        log.log({email})
        this.authService.logout(email);
      });
    })
  }

}
